const environment = {
    //  apiUrl: 'https://localhost:44325/api/',  // local
    // apiCarparkUrl: 'https://localhost:44325/api/',  // Carpark local

    // apiUrl: 'https://localhost/api/',  // Local Server
    // apiCarparkUrl: 'http://localhost:8086/api/',  // Local Server
    // apiReport: 'https://localhost:446/', // Local Server
    // apiPayment: 'https://localhost:449/', // Local Server
    // webPayment: 'https://tgg-payment.tgh.co.th/', // Local 

    apiUrl: 'https://fineday-api.objective-faraday.119-59-118-127.plesk.page/api/',  // VPS Server
    apiCarparkUrl: 'https://fineday-api.objective-faraday.119-59-118-127.plesk.page/api/',  // VPS Server
    apiReport: 'https://tgq-reports.tgh.co.th/', // VPS Server
    apiPayment: 'https://tgq-apipayment.tgh.co.th/', // VPS Server
    webPayment: 'https://tgq-payment.tgh.co.th/', // VPS Server
}
export default environment